









































import Vue from 'vue'
export default Vue.extend({
  name: 'Paginator',
  props: {
    itemsPerPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    }
  },
  computed: {
    lowerRecord (): number {
      return (this.currentPage - 1) * this.itemsPerPage
    },
    outputLowerRecord (): number {
      return this.lowerRecord < 0 ? 0 : this.lowerRecord + 1
    },
    upperRecord (): number {
      const upperRecord = this.lowerRecord + this.itemsPerPage
      return upperRecord < this.totalItems ? upperRecord : this.totalItems
    }
  },
  methods: {
    requestNextPage () {
      if (this.currentPage !== this.totalPages) {
        this.$emit('page-changed', this.currentPage + 1)
      }
    },
    requestPreviousPage () {
      if (this.currentPage !== 1) {
        this.$emit('page-changed', this.currentPage - 1)
      }
    }
  }
})
